import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-traffic-map",
  meta: {},
  displayComponent: () => import("./component"),
  settingsComponent: () => import("../locations-common/settings"),
  presets: [
    {
      label: "bcm:widgets.traffic-map.name",
      description: "bcm:widgets.traffic-map.description",
      imageLink: require("./screenshot.png"),
      layout: [8, 8],
      widget: {
        config: {},
      },
    },
  ],
});
